import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { SearchPatientRoutingModule } from './search-patient.routing';
import { SearchPatientComponent } from './search-patient.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
    declarations: [
        SearchPatientComponent
    ],
    imports: [SearchPatientRoutingModule, SharedModule, ReactiveFormsModule, FormsModule, CommonModule],
    providers: [],
    bootstrap: []
})
export class SearchPatientModule {
}




// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/search-patient/search-patient.module.ts